import {
  FeatureName,
  Media,
  MediaQuestionConfig,
  MediaResponseState,
  MediaType,
  useFindMedia,
  useGrippContext,
  useIsFeatureEnabled,
} from '@gripp/shared-logic';
import { useFieldArray, useWatch } from 'react-hook-form';
import { useFormContext } from '../../../../forms';
import { HorizontalMediaGallery } from '../../../../media';
import {
  RoutineQuestionExecutionForm,
  RoutineQuestionExecutionFormProps,
} from '../types';

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
const MediaQuestionExecutionFormOld: RoutineQuestionExecutionForm<
  MediaQuestionConfig,
  MediaResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    MediaQuestionConfig,
    MediaResponseState
  >
) => {
  const { mediaPickerComponent: MediaPicker } = useGrippContext();
  const fieldName = `responses.${props.responseIndex}.mediaIds`;
  const { control } = useFormContext();
  control.register(fieldName, { value: [] });
  const { append, remove } = useFieldArray({
    control,
    name: fieldName,
  });

  const mediaIds: string[] = useWatch({ control, name: fieldName }) ?? [];

  const existingMedia = useFindMedia({
    filter: { id: { in: mediaIds.length > 0 ? mediaIds : undefined } },
  });

  const onMediaAdded = (mediaItem: Media) => {
    append(mediaItem.id);
  };

  const onMediaDeleted = (mediaId: string) => {
    const index = mediaIds.indexOf(mediaId);
    if (index >= 0) remove(index);
  };

  return (
    <HorizontalMediaGallery
      media={existingMedia}
      onMediaAdded={onMediaAdded}
      mediaPicker={MediaPicker}
      acceptedMediaTypes={[MediaType.Image]}
      onMediaDeleted={onMediaDeleted}
      canEditMedia={true}
      onUploadingChanged={props.toggleProcessing}
      workspaceId={props.workspaceAsset.workspace.id}
    />
  );
};

// TODO: Crop Circle Redesign | Remove to MediaQuestionExecutionFormBase after feature is fully rolled out
const MediaQuestionExecutionFormBase: RoutineQuestionExecutionForm<
  MediaQuestionConfig,
  MediaResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    MediaQuestionConfig,
    MediaResponseState
  >
) => {
  const { mediaPickerComponent: MediaPicker } = useGrippContext();
  const fieldName = `responses.${props.responseIndex}.mediaIds`;
  const { control } = useFormContext();
  control.register(fieldName, { value: [] });
  const { append, remove } = useFieldArray({
    control,
    name: fieldName,
  });

  const mediaIds: string[] = useWatch({ control, name: fieldName }) ?? [];

  const existingMedia = useFindMedia({
    filter: { id: { in: mediaIds.length > 0 ? mediaIds : undefined } },
  });

  const onMediaAdded = (mediaItem: Media) => {
    append(mediaItem.id);
  };

  const onMediaDeleted = (mediaId: string) => {
    const index = mediaIds.indexOf(mediaId);
    if (index >= 0) remove(index);
  };

  return (
    <HorizontalMediaGallery
      media={existingMedia}
      onMediaAdded={onMediaAdded}
      mediaPicker={MediaPicker}
      acceptedMediaTypes={[MediaType.Image]}
      onMediaDeleted={onMediaDeleted}
      canEditMedia={true}
      onUploadingChanged={props.toggleProcessing}
      workspaceId={props.workspaceAsset.workspace.id}
      pickerMarginTop={0}
    />
  );
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
export const MediaQuestionExecutionForm: RoutineQuestionExecutionForm<
  MediaQuestionConfig,
  MediaResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    MediaQuestionConfig,
    MediaResponseState
  >
) => {
  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);

  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  if (!isCropCircleRedesignEnabled) {
    return <MediaQuestionExecutionFormOld {...props} />;
  }

  // TODO: Crop Circle Redesign | Remove to MediaQuestionExecutionFormBase after feature is fully rolled out
  return <MediaQuestionExecutionFormBase {...props} />;
};
